(() => {
  const init = () => document.querySelectorAll('[data-ssk-kayak-finder]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const section = root.closest('[data-section-type="collection"]');
    const header = document.querySelector('.shopify-section__header');
    const groups = [...root.querySelectorAll('.ssk-kayak-finder__group')];
    const closeGroup = (group, restoreFocus = false) => {
      group.open = false;
      if (restoreFocus) group.querySelector('summary').focus();
    };
    const updatePosition = () => {
      const sticky = header && ['sticky','fixed'].includes(getComputedStyle(header).position);
      root.style.setProperty('--ssk-kayak-sticky-top', `${sticky ? Math.max(0,header.getBoundingClientRect().bottom) : 0}px`);
      root.style.setProperty('--ssk-kayak-popover-top', `${Math.max(8,root.getBoundingClientRect().bottom+8)}px`);
    };
    updatePosition();
    if (header) new ResizeObserver(updatePosition).observe(header);
    new ResizeObserver(updatePosition).observe(root);
    let frame;
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(() => { updatePosition(); frame = null; }); }, { passive: true });
    window.addEventListener('resize',updatePosition);
    const updateSelection = target => {
      const group = target.closest('.ssk-kayak-finder__group');
      if (!group) return;
      const price = group.dataset.sskCategory === 'price';
      const count = price ? Number([...group.querySelectorAll('input[type="number"]')].some(input => input.value !== '')) : group.querySelectorAll('input:checked:not(:disabled)').length;
      const badge = group.querySelector('[data-ssk-selected]');
      badge.textContent = String(count);
      badge.dataset.count = String(count);
      badge.setAttribute('aria-label',badge.dataset.sskCountLabel.replace('__COUNT__',String(count)));
    };
    root.addEventListener('input',event=>updateSelection(event.target));
    root.addEventListener('change', event => {
      event.stopPropagation();
      updateSelection(event.target);
      if (event.target.matches('select[name="sort_by"]')) event.target.form.requestSubmit();
    });
    root.querySelectorAll('[data-ssk-kayak-form]').forEach(form => form.addEventListener('submit', () => {
      form.querySelectorAll('input[type="number"]').forEach(input => { if (input.value === '') input.disabled=true; });
    }));
    groups.forEach(group => {
      group.addEventListener('toggle', () => { if (group.open) { groups.forEach(other => { if(other!==group) closeGroup(other); }); updatePosition(); } });
      group.querySelector('[data-ssk-close-group]').addEventListener('click',()=>closeGroup(group,true));
      group.addEventListener('focusout',event=>{ if (event.relatedTarget && !group.contains(event.relatedTarget)) closeGroup(group); });
      group.addEventListener('keydown',event=>{ if(event.key==='Escape' && group.open){event.preventDefault();event.stopPropagation();closeGroup(group,true);} });
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) groups.forEach(group=>closeGroup(group)); });
    section.addEventListener('click', event => {
      const target=event.target.closest('.pagination [data-page], [data-action="clear-filters"]');
      if (!target) return;
      const url=target.getAttribute('data-url')||target.getAttribute('href');
      if (url) { event.preventDefault(); event.stopImmediatePropagation(); location.assign(url); }
    },true);
    window.addEventListener('popstate',()=>location.reload());
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();
